import React, { useEffect, useState } from 'react';
import Axios from '../../config/axios';
import logo from '../../img/login_logo.png';
import './navigation.css';
import { Popover, Select, Drawer, Modal, Empty } from 'antd';
/*import Helmet from 'react-helmet';*/
import CustomSearch from './CustomSearch';
import { toast, confirm } from '@rickylandino/react-messages';
//import { FaUserCheck } from 'react-icons/fa';
//import { FaUserPlus } from 'react-icons/fa';
import { FaPersonBooth } from 'react-icons/fa';
import { TbReportMoney } from 'react-icons/tb';
import { TbUserCheck } from 'react-icons/tb';
import { TbUserPlus } from 'react-icons/tb';
import { TbReport } from 'react-icons/tb';
import { TbBook } from 'react-icons/tb';
import { GrShop } from 'react-icons/gr';
import { BsMegaphone } from 'react-icons/bs';
import { MdOutlineWidgets } from 'react-icons/md';
import { BsGear } from 'react-icons/bs';
import SlidingPane from 'react-sliding-pane';
import $ from 'jquery';
import { useNavigate } from "react-router-dom";
import { activeRoute } from '../../services/SpaService';
import { takeWhile } from 'rxjs/operators';
import Globals from '../../config/globals';
import { useForm, Controller } from "react-hook-form";
import { HubConnectionBuilder, LogLevel } from '@microsoft/signalr';
import { getUnreadAlertsByUser, markAlertRead } from '../../services/AlertsService';
import Moment from 'moment';
import ReportsSlider from '../ReportingOutput/ReportsSlider';
import SelectWidgetSlider from './SelectWidgetSlider';
import AddJSSProspect from '../Prospects/AddJSSProspect';
import CustomerDetailSlider from '../Customers/CustomerDetailSlider';
import { componentMap } from '../Helpers/Widgets';

import WidgetRegistrationCounts from '../Widgets/WidgetRegistrationCounts';
import WidgetSalesByShow from '../Widgets/WidgetSalesByShow';
import WidgetMailCodeCounts from '../Widgets/WidgetMailCodeCounts';
import WidgetCallSheets from '../Widgets/WidgetCallSheets';
import WidgetRepDocumentLibrary from '../Widgets/WidgetRepDocumentLibrary';
import WidgetRepEmailTemplateLibrary from '../Widgets/WidgetRepEmailTemplateLibrary';
import WidgetRegistrationScorecard from '../Widgets/WidgetRegistrationScorecard';
import WidgetFEPMetricsByShow from '../Widgets/WidgetFEPMetricsByShow';

const DEFAULT_TITLE = 'Design-2-Part';

export default function TopNav(props) {
    const userInfo = JSON.parse(window.sessionStorage.getItem("userInfo"));
    const navigate = useNavigate();

    var urlend = window.api.slice(-1) === '/' ? 'hubs/alert' : '/hubs/alert';
    const url = window.api + urlend;

    const connection = new HubConnectionBuilder()
        .configureLogging(LogLevel.Error)
        .withUrl(url)
        .withAutomaticReconnect()
        .build();

    const [alertsList, setAlertsList] = useState([]);
    const [showAlertNotification, setShowAlertNotification] = useState(false);
    const { register, getValues, setValue, control, watch } = useForm();
    const [activityViewShown, setActivityViewShown] = useState(false);
    const [title, setTitle] = useState(DEFAULT_TITLE);

    const [state, setState] = useState({
        showReportsSlider: false,
        showJSTReportsSlider: false,
        showSelectWidgetSlider: false,
        showAddJSSProspectSlider: false,
        showAddCustomerSlider: false,
        myWidgets: [],
        allWidgets: [],
        showWidgetPane: false,
        showWidgetModal: false,
        selectedWidget: {},
        selectedWidgetName: '',
        widgetIconVisible: false
    });

    //const componentMap = [
    //    { "WidgetName": "RegistrationCounts", "WidgetComponent": <WidgetRegistrationCounts /> },
    //    { "WidgetName": "SalesByShow", "WidgetComponent": <WidgetSalesByShow /> },
    //    { "WidgetName": "MailCodeCounts", "WidgetComponent": <WidgetMailCodeCounts /> },
    //    { "WidgetName": "CallSheets", "WidgetComponent": <WidgetCallSheets /> },
    //    { "WidgetName": "RepDocumentLibrary", "WidgetComponent": <WidgetRepDocumentLibrary /> },
    //    { "WidgetName": "RepEmailTemplateLibrary", "WidgetComponent": <WidgetRepEmailTemplateLibrary /> }
    //];

    useEffect(() => {
        var alive = true;

        setValue('currentUser', userInfo);
        
        getUnreadAlerts();

        activeRoute.pipe(takeWhile(() => alive)).subscribe((route) => {
            switch (route) {
                case '/dashboard':
                    $(".header-icon").removeClass("active");
                    $("#dashboardBtn").addClass("active");
                    break;
                case '/accounts':
                    $(".header-icon").removeClass("active");
                    $("#accountsBtn").addClass("active");
                    break;
                //case '/sub-item-1':
                //case '/sub-item-2':
                //case '/sub-item-3':
                //    $(".header-icon").removeClass("active");
                //    $("#option2").addClass("active");
                //    break;
                case '/campaigns':
                    $(".header-icon").removeClass("active");
                    $("#campaignsBtn").addClass("active");
                    break;
                case '/opportunities':
                    $(".header-icon").removeClass("active");
                    $("#opportunitiesBtn").addClass("active");
                    break;
                default:
                    $(".header-icon").removeClass("active");
                    break;
            }
        });

        connection.start()
            .then(result => {
                connection.on('ReceiveAlert', alerts => {
                    let al = [...alertsList];
                    let san = false;

                    alerts.forEach(a => {
                        if (
                            (
                                a.alert.recipient === userInfo.userId ||
                                (userInfo.userQueueAccess?.includes('JSS Admin Review') && a.alert.recipient === 'JSS Admin Review')
                            ) && !al.find(existingAlert => existingAlert.alert.alert_ID === a.alert.alert_ID)) {
                            a.newAlert = true;
                            al.unshift(a);
                            san = true;
                        }
                    });

                    setAlertsList(al);
                    setShowAlertNotification(san);
                    setActivityViewShown(false);

                    if (san) {
                        setTitle('You have a new alert');
                    } else {
                        setTitle(DEFAULT_TITLE);
                    }
                });
            })
            .catch(e => {
                console.log("SignalR Error!");
                console.log('Connection failed: ', e);
            });

        LoadDashboardWidgets();
    }, []);

    useEffect(() => {        
        setState({
            ...state,
            showSelectWidgetSlider: false,
            showAddJSSProspectSlider: false,
            showAddCustomerSlider: false
        });

    }, [props]);

    function getUnreadAlerts() {
        getUnreadAlertsByUser(userInfo.userId).then(data => {
            setAlertsList(data);
        });
    }

    async function LoadDashboardWidgets() {
        let postdata = {};
        postdata.webcmRoles = userInfo.webcmRoles;
        postdata.jobShopDivision = userInfo.jobShopDivision;

        await Axios.post('/api/GetDashboardWidgets', postdata
        ).then(async response => {
            const myWidgets = await response.data.myDashboardWidgets;
            const allWidgets = await response.data.allDashboardWidgets;

            let widgetIconVisible = true;
            if (myWidgets === null || myWidgets.length === 0) {
                widgetIconVisible = false;
            }

            setState({
                ...state,
                myWidgets: myWidgets,
                allWidgets: allWidgets,
                widgetIconVisible,
                showSelectWidgetSlider: false
            });
        }).catch(error => {
            console.log(error);
        });
    }

    //function createComponent(componentName, props, children) {
    //    console.log(componentName);

    //    var Component = React.createElement(eval(componentName), props, children);
    //    return Component;
    //}

    //function createComponent(componentName, props, children) {
    //    console.log(componentName);

    //    var component = React.createClass({ componentName});

    //    //var component = React.createElement(eval(componentName), props, children);
    //    return component;
    //}

    //function createComponent(componentName, props, children) {
    //    //var component = Components[itemData['itemClass']]);

    //    //return React.createElement('WidgetMailCodeCounts', props, children);
    //    console.log('here in createComponent');

    //    //var MyComponent = <div dangerouslySetInnerHTML={{ __html: 'WidgetMailCodeCounts' }} />

    //    const MyComponent = 'WidgetMailCodeCounts';
    //    return <MyComponent />;

    //    //return React.createElement('WidgetMailCodeCounts', {
    //    //    //data: itemData,
    //    //    //key: itemData['id']
    //    //});
    //}

    async function loadSelectedWidget(widgetId, widgetName) {
        var selectedWidget;

        componentMap.forEach((c, idx) => {
            if (c.WidgetName === widgetId) {
                selectedWidget = c.WidgetComponent;
            }
        });

        console.log(selectedWidget);

        setState({
            ...state,
            showReportsSlider: false,
            showSelectWidgetSlider: false,
            showWidgetPane: true,
            showWidgetModal: false,
            selectedWidget: selectedWidget,
            selectedWidgetName: widgetName.toString()
        });
    }

    function handleNavigation(event) {
        event.preventDefault();

        switch (event.target.id) {
            case 'dashboardBtn':
                $(".listHeader").removeClass("active open");
                navigate("/dashboard", { replace: true });
                break;
            case 'accountsBtn':
                $(".listHeader").removeClass("active open");
                navigate("/accounts", { replace: true, state: { pageNumber: 1, selectedAccountId: null } });
                /*navigate("/accounts", { replace: true });*/
                break;
            case 'importAttachmentsBtn':
                toast.success("Import SalesForce.com Attachments Clicked");
                break;
            case 'companysearch':
                $(".listHeader").removeClass("active open");
                navigate("/customersearch", { replace: true, state: { fromTopNav: true } });
                break;
            case 'queryBuilder':
                $(".listHeader").removeClass("active open");
                navigate("/querybuilder", { replace: true, state: { querytopreload: null } });
                break;
            case 'reportingBtn':
                setState({
                    ...state,
                    showReportsSlider: true,
                    showJSTReportsSlider: false,
                    showAddJSSProspectSlider: false,
                    showSelectWidgetSlider: false,
                    showAddCustomerSlider: false
                });
                break;
            case 'managementPanelBtn':
                $(".listHeader").removeClass("active open");
                navigate("/management-dashboard", { replace: true });
                break;
            case 'addJSSProspect':
                //$(".listHeader").removeClass("active open");
                //navigate("/addprospect", { replace: true, state: { fromTopNav: true } });

                setState({
                    ...state,
                    showReportsSlider: false,
                    showJSTReportsSlider: false,
                    showAddJSSProspectSlider: true,
                    showSelectWidgetSlider: false,
                    showAddCustomerSlider: false
                });

                break;
            case 'addCustomer':
                setState({
                    ...state,
                    showSelectWidgetSlider: false,
                    showReportsSlider: false,
                    showJSTReportsSlider: false,
                    showAddJSSProspectSlider: false,
                    showAddCustomerSlider: true
                });

                break;
            case 'suppliedServicesMgr':
                $(".listHeader").removeClass("active open");
                navigate("/supplied-services-manager", { replace: true });
                break;
            
            default:
                break;
        }

        //$('.subTabs').parent('li').removeClass('active');
        //$('#' + event.target.id).parent('li').addClass('active');
    }

    function handleLogout(event) {
        confirm({
            title: "You are about to logout",
            content: "Are you sure you would like to proceed?",
            buttons: ["Yes", "No"],
            theme: window.sessionStorage.getItem("theme") === 'dark' ? 'dark' : 'light'
        }, (buttonPressed) => {
            if (buttonPressed === 'Yes') {

                event.preventDefault();

                navigate("/", { replace: true });

                return 0;
            } else {
                return 0;
            }
        });
    }

    function handleDivisonChange(event) {
        const target = event.target;

        userInfo.jobShopDivision = target.value;
        window.sessionStorage.setItem("userInfo", JSON.stringify(userInfo));

        setValue('currentUser', userInfo);
        setState({ ...state });

        LoadDashboardWidgets();

        navigate("/dashboard");
    }

    function handleWidgetsClick() {
        setState({
            ...state,
            showSelectWidgetSlider: true,
            showReportsSlider: false,
            showJSTReportsSlider: false,
            showAddJSSProspectSlider: false,
            showAddCustomerSlider: false
        });
    }

    function hideWidgetPane() {
        setState({
            ...state,
            showWidgetPane: false,
            showWidgetModal: false
        });
    }

    function hideWidgetModal() {
        setState({
            ...state,
            showWidgetPane: false,
            showWidgetModal: false
        });
    }

    function toggleActivityView() {
        if (activityViewShown) {
            let al = [...alertsList];
            al.forEach(a => {
                a.newAlert = false;
            });

            setAlertsList(al);
        }

        $("#app-notification").toggleClass("show");

        setActivityViewShown(true);
        setShowAlertNotification(false);
        setTitle(DEFAULT_TITLE);
    }

    function handleSingleDismiss(alert, idx) {
        markAlertRead(alert).then(data => {
            if (data >= 1) {
                let al = [...alertsList];
                al.splice(idx, 1);

                setAlertsList(al);
            }
        });
    }

    const { Option } = Select;

    return (
        <nav className="navbar navbar-expand-lg navbar-light bg-header">
            {props.showLeftNav === false ?
                <div className="navbar-brand hover">
                    <img alt="Design-2-Part Company" id="dashboardBtn" onClick={handleNavigation} src={logo} style={{ height: '75px' }} />
                </div>
                :
                <div></div>
            }

            <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbar-toggle" aria-controls="navbar-toggle" aria-expanded="false" aria-label="Toggle navigation">
                <span className="navbar-toggler-icon"></span>
            </button>

            <div className="collapse navbar-collapse" id="navbar-toggle">
                <ul className="navbar-nav mt-2 mt-lg-0 me-auto">
                    <li className="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
                        {/*<div>*/}
                        {/*    <span className="header-icon mimicA top-nav-item" id="customersBtn" onClick={handleNavigation}>*/}
                        {/*        <TbUserCheck className="fa-1x text-icon" id="customersBtn" onClick={handleNavigation} /> <span className="top-nav-item-desc" id="customersBtn" onClick={handleNavigation}>Customers</span>*/}
                        {/*    </span>*/}
                        {/*</div>*/}
                        <div className="dropdown">
                            <span className="dropbtn header-icon mimicA top-nav-item">
                                <FaPersonBooth className="fa-1x text-icon" id="showsBtn" /> <span className="top-nav-item-desc" id="showsBtn">Shows</span>
                            </span>
                            {userInfo.jobShopDivision === 'JSS' &&
                                <div className="dropdown-content">
                                    <li id="suppliedServicesMgr" onClick={handleNavigation}>
                                        <span id="suppliedServicesMgr" className="subTabs waves-effect waves-themed active" onClick={handleNavigation}>
                                            Supplied Services Manager
                                        </span>
                                    </li>
                                    {/*<li id="showLogistics" onClick={handleNavigation}>*/}
                                    {/*    <span id="showLogistics" className="subTabs waves-effect waves-themed active" onClick={handleNavigation}>*/}
                                    {/*        Show Logistics*/}
                                    {/*    </span>*/}
                                    {/*</li>*/}
                                    {/*<li id="addCustomer" onClick={handleNavigation}>*/}
                                    {/*    <span id="addCustomer" className="subTabs waves-effect waves-themed active" onClick={handleNavigation}>*/}
                                    {/*        Add A New Customer*/}
                                    {/*    </span>*/}
                                    {/*</li>*/}
                                </div>
                            }
                        </div>
                    </li>
                    <li className="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
                        {/*<div>*/}
                        {/*    <span className="header-icon mimicA top-nav-item" id="customersBtn" onClick={handleNavigation}>*/}
                        {/*        <TbUserCheck className="fa-1x text-icon" id="customersBtn" onClick={handleNavigation} /> <span className="top-nav-item-desc" id="customersBtn" onClick={handleNavigation}>Customers</span>*/}
                        {/*    </span>*/}
                        {/*</div>*/}
                        <div className="dropdown">
                            <span className="dropbtn header-icon mimicA top-nav-item">
                                <TbUserCheck className="fa-1x text-icon" id="customersBtn" /> <span className="top-nav-item-desc" id="customersBtn">Customers</span>
                            </span>
                            {userInfo.jobShopDivision === 'JSS' &&
                                <div className="dropdown-content">
                                    <li id="companysearch" onClick={handleNavigation}>
                                        <span id="companysearch" className="subTabs waves-effect waves-themed active" onClick={handleNavigation}>
                                            Customer Search
                                        </span>
                                    </li>
                                    <li id="addCustomer" onClick={handleNavigation}>
                                        <span id="addCustomer" className="subTabs waves-effect waves-themed active" onClick={handleNavigation}>
                                            Add A New Customer
                                        </span>
                                    </li>
                                    <li id="addJSSProspect" onClick={handleNavigation}>
                                        <span id="addJSSProspect" className="subTabs waves-effect waves-themed active" onClick={handleNavigation}>
                                            Add A New Company
                                        </span>
                                    </li>
                                    <li id="queryBuilder" onClick={handleNavigation}>
                                        <span id="queryBuilder" className="subTabs waves-effect waves-themed active" onClick={handleNavigation}>
                                            Query Builder
                                        </span>
                                    </li>
                                </div>
                            }
                            {userInfo.jobShopDivision === 'JST' &&
                                <div className="dropdown-content">
                                    <li id="companysearch" onClick={handleNavigation}>
                                        <span id="companysearch" className="subTabs waves-effect waves-themed active" onClick={handleNavigation}>
                                            Customer Search
                                        </span>
                                    </li>
                                    <li id="addAdvertiser" onClick={handleNavigation}>
                                        <span id="addAdvertiser" className="subTabs waves-effect waves-themed active" onClick={handleNavigation}>
                                            Add A New Advertiser
                                        </span>
                                    </li>
                                    <li id="addJSTProspect" onClick={handleNavigation}>
                                        <span id="addJSTProspect" className="subTabs waves-effect waves-themed active" onClick={handleNavigation}>
                                            Add A New Prospect
                                        </span>
                                    </li>
                                    <li id="queryBuilder" onClick={handleNavigation}>
                                        <span id="queryBuilder" className="subTabs waves-effect waves-themed active" onClick={handleNavigation}>
                                            Query Builder
                                        </span>
                                    </li>
                                </div>
                            }
                        </div>
                    </li>

                    {/*<li className="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">*/}
                    {/*    <div>*/}
                    {/*        <span className="header-icon mimicA top-nav-item" id="prospectsBtn" onClick={handleNavigation}>*/}
                    {/*            <TbUserPlus className="fa-1x text-icon" id="prospectsBtn" onClick={handleNavigation} /> <span className="top-nav-item-desc" id="prospectsBtn" onClick={handleNavigation}>Prospects</span>*/}
                    {/*        </span>*/}
                    {/*    </div>*/}
                    {/*</li>*/}

                    <li className="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
                        <div>
                            <span className="header-icon mimicA top-nav-item" id="arBtn" onClick={handleNavigation}>
                                <TbReportMoney className="fa-1x text-icon" id="arBtn" onClick={handleNavigation} /> <span className="top-nav-item-desc" id="arBtn" onClick={handleNavigation}>A/R</span>
                            </span>
                        </div>
                    </li>

                    {userInfo.jobShopDivision === 'JST' &&
                        <li className="nav-item">
                            <div className="dropdown">
                                <span className="dropbtn header-icon mimicA top-nav-item" id="marketingBtn" onClick={handleNavigation}>
                                    <BsMegaphone className="fa-1x text-icon" id="marketingBtn" /> <span className="top-nav-item-desc" id="marketingBtn" onClick={handleNavigation}>Marketing</span>
                                </span>
                            </div>
                        </li>
                    }

                    <li className="nav-item">
                        <div className="dropdown">
                            <span className="dropbtn header-icon mimicA top-nav-item" id="reportingBtn" onClick={handleNavigation}>
                                <TbReport className="fa-1x text-icon" id="reportingBtn" /> <span className="top-nav-item-desc" id="reportingBtn" onClick={handleNavigation}>Reporting</span>
                            </span>
                        </div>
                    </li>

                    {userInfo.jobShopDivision === 'JST' &&
                        <li className="nav-item">
                            <div className="dropdown">
                                <span className="dropbtn header-icon mimicA top-nav-item" id="buyersguideBtn" onClick={handleNavigation}>
                                    <GrShop className="fa-1x text-icon" id="buyersguideBtn" /> <span className="top-nav-item-desc" id="buyersguideBtn" onClick={handleNavigation}>Buyers Guide</span>
                                </span>
                            </div>
                        </li>
                    }

                    <div className="search-div full-size ms-auto">
                        <CustomSearch />
                    </div>
                    <div className="float-right" id="app-notification">
                        <span className={(showAlertNotification ? 'bounce-6 bounce-icon' : '') + " header-icon top-nav-item fs-21"} title={"You have notifications"} onClick={toggleActivityView}>
                            <i className="far fa-bell fa-1x text-icon" />
                            {alertsList?.length > 0 && <span className="badge badge-icon">{alertsList.length}</span>}
                        </span>
                        <div className="dropdown-menu dropdown-menu-animated dropdown-xl">
                            <div className="dropdown-header d-flex justify-content-center align-items-center rounded-top mb-2">
                                <h6 className="m-0 text-center">
                                    Alerts
                                </h6>
                            </div>
                            <div className="d-flex flex-column h-100">
                                <div className="h-auto">
                                    {alertsList?.length > 0 ? alertsList.map((a, idx) =>

                                        <div id="eventRow" className={"row openEventRow fs-13 " + (a.newAlert ? 'focusEvent' : '')} key={idx}>
                                            {a.alert.recipient === 'JSS Admin Review' ?
                                                <>
                                                    <div className="col-12">This is an alert to be configured for JSS Admin Review Member</div>
                                                </>
                                                :
                                                <>
                                                    <div className="col-12">
                                                        <small className="float-right">{Moment(a.alert.alertDate).format('LLL')}</small>
                                                    </div>
                                                    <div className="col-12">
                                                        <small className="float-right">{a.worklistViewModel.worklistItem?.epicoreCustomerName}</small>
                                                    </div>
                                                    <div className="col-12">
                                                        <strong className="">{a.worklistViewModel?.worklistItem?.itemDetail + (a.alert.alertContent ? ` - ${a.alert.alertContent}` : '')}</strong>

                                                        <div className="ellipsis-text"><em>Completed By: {a.sentBy?.firstName} {a.sentBy?.lastName}</em></div>
                                                    </div>
                                                </>
                                            }
                                            <div className="col-lg-12">

                                                <button id="dismissAlertBtn" className="float-right mt-2 mr-3 notifications-btn" onClick={() => handleSingleDismiss(a.alert, idx)}>Dismiss</button>

                                            </div>
                                            
                                        </div>
                                    )
                                        :
                                        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="No Alerts" />
                                    }
                                </div>
                            </div>
                            <div className="dropdown-menu-footer">
                                {/*<span href="#" className="fs-xs fw-500 ml-auto float-left"><button className="notifications-btn">Dismiss All</button></span>*/}
                                <button className="notifications-btn float-right" onClick={toggleActivityView}>Close</button>
                            </div>

                        </div>
                    </div>

                    <li className="nav-item" style={state.widgetIconVisible === true ? {} : { display: 'none' }}>
                        <div className="dropdown">
                            <span className="header-icon mimicA top-nav-item" id="widgets">
                                <MdOutlineWidgets className="fa-2x text-icon" id="widgetsBtn" onClick={handleWidgetsClick} />
                            </span>
                        </div>
                    </li>
                    
                    <div className="seperator"></div>

                    {(userInfo.userId === 'dlandino' || userInfo.userId === 'blebo') &&
                        <div onClick={handleNavigation}>
                            <span className="header-icon mimicA top-nav-item" id="managementPanelBtn">
                                <BsGear className="fa-2x text-icon" id="managementPanelBtn" />
                            </span>
                        </div>
                    }

                    <div className="current-user">Welcome: {userInfo.userName}</div>
                    {userInfo.userType === 'admin' &&
                        <div className="header-search pull-left pt-4">
                            <span><input type="radio" name="jobshopdivision" value="JSS" checked={userInfo.jobShopDivision === 'JSS'} onChange={handleDivisonChange} /></span>&nbsp;JSS
                            <span style={{ "paddingLeft": "10px" }}><input type="radio" name="jobshopdivision" value="JST" checked={userInfo.jobShopDivision === 'JST'} onChange={handleDivisonChange} /></span>&nbsp;JST
                        </div>
                    }
                    <div>
                        <span className="header-icon mimicA top-nav-item" onClick={handleLogout}>
                            <i className="fas fa-sign-out-alt logoutIcon" onClick={handleLogout} />
                        </span>
                    </div>
                </ul>
            </div>

            {state.showReportsSlider && <ReportsSlider showModal={state.showReportsSlider} hideModal={() => setState({ ...state, showReportsSlider: false })} loadSelectedWidget={loadSelectedWidget} />}

            {state.showSelectWidgetSlider && <SelectWidgetSlider showDrawer={state.showSelectWidgetSlider} myWidgets={state.myWidgets} loadSelectedWidget={loadSelectedWidget} />}

            {state.showAddJSSProspectSlider && <AddJSSProspect showPane={state.showAddJSSProspectSlider} hidePane={() => setState({ ...state, showAddJSSProspectSlider: false })} />}

            {state.showAddCustomerSlider && <CustomerDetailSlider selectedCustomerId={null} showPane={state.showAddCustomerSlider} hidePane={() => setState({ ...state, showAddCustomerSlider: false })} />}

            <Drawer
                closeIcon={<i className="fas fa-chevron-right float-left"></i>}
                title={state.selectedWidgetName}
                placement={'right'}
                onClose={hideWidgetPane}
                visible={state.showWidgetPane}
                key='editEmployee'
                width={'75%'}

                footer={
                    <div className="d-flex justify-content-between">
                        <div>
                            <button className="btn btn-outline-primary margin-left-15 float-right" onClick={hideWidgetPane}>Close</button>
                        </div>
                    </div>
                }
            >
                <div className="row">
                    <div className="col-12">
                        {state.selectedWidgetName === 'Registration Counts' && <WidgetRegistrationCounts />}
                        {state.selectedWidgetName === 'Sales By Show' && <WidgetSalesByShow />}
                        {state.selectedWidgetName === 'Mail Code Counts' && <WidgetMailCodeCounts />}
                        {state.selectedWidgetName === 'Call Sheets' && <WidgetCallSheets />}
                        {state.selectedWidgetName === 'My Documents' && <WidgetRepDocumentLibrary />}
                        {state.selectedWidgetName === 'My Email Templates' && <WidgetRepEmailTemplateLibrary />}
                        {state.selectedWidgetName === 'Registration Scorecard' && <WidgetRegistrationScorecard showsSelected={false} />}
                        {state.selectedWidgetName === 'My Email Templates' && <WidgetRepEmailTemplateLibrary />}
                        {state.selectedWidgetName === 'FEP Metrics By Show' && <WidgetFEPMetricsByShow />}
                        {/*{state.selectedWidget}*/}
                    </div>
                </div>
            </Drawer>

            <Modal
                visible={state.showWidgetModal}
                title={state.modalTitle}
                onCancel={hideWidgetModal}
                footer={null}
            >
                {state.selectedWidget}

            </Modal>
        </nav>
    );
}